import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import RecentNews from '@/components/page-components/noticias/recent-news';
import AnaliticaSocialNetworks from '@/components/shared/analitica-social-networks';
import ShareArticleAdminComponent from '../page-components/noticias/share-article-admin';
import ArticleContent from './article/ArticleContent';
import NoticiaEntidadesRelacionadas from './article/NoticiaEntidadesRelacionadas';
import ComentariosSection from './ComentariosSection';
import NoticiaAutorYCompartir from './NoticiaAutorYCompartir';

const NoticiaPageComponent = ({ articulo, image, slug }) => {
    return (
        <Box className="noticia-page-component">
            {/* 📰 Compartir Artículo */}
            <ShareArticleAdminComponent
                title={`${articulo.title}`}
                ruta={`/noticias/${slug}`}
                icon={'🗞️'}
                hashtags={['analiticaFantasyNoticias']}
            />

            <NoticiaEntidadesRelacionadas noticia={articulo} />

            {/* 📄 Contenido Principal */}
            <Grid container spacing={2}>
                <Grid size={{ xs: 12, md: 8 }}>
                    <Box className="noticia-page-component__content">
                        <Box className="articulo-content-container-top">
                            <Typography
                                variant="h1"
                                style={{ marginBottom: '8px', fontSize: '20px', lineHeight: '1.4' }}
                            >
                                {articulo.title}
                            </Typography>
                            <Typography>{articulo.description}</Typography>
                        </Box>

                        <ArticleContent
                            articulo={articulo}
                            image={image}
                            shareComponent={
                                <ComentariosSection
                                    slug={slug}
                                    title={articulo.title}
                                    commentsCount={articulo.commentsCount}
                                >
                                    {(onOpenComments, localCommentsCount) => (
                                        <NoticiaAutorYCompartir
                                            author={articulo.author}
                                            shareUrl={`${process.env.NEXT_PUBLIC_SITE_URL}/noticias/${slug}`}
                                            title={articulo.title}
                                            commentsCount={localCommentsCount}
                                            onOpenComments={onOpenComments}
                                        />
                                    )}
                                </ComentariosSection>
                            }
                        />

                        <AnaliticaSocialNetworks />
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <RecentNews slug={slug} />
                </Grid>
            </Grid>
        </Box>
    );
};

export default NoticiaPageComponent;
